import http from "./Http";

const getAll = async (dlid) => {
    return http.get(`/homepage-categories?dlid=${dlid}`);
};

const get = async (id) => {
    return http.get(`/homepage-categories/${id}`);
};

const create = async (body) => {
    return http.post("/homepage-categories", body);
};

const update = async (id, body) => {
    return http.put(`/homepage-categories/${id}`, body);
};

const remove = async (id) => {
    return http.delete(`/homepage-categories/${id}`);
};

const uploadImage = async (file, dealerId) => {
    const formData = new FormData();
    // Append fields before files so they are available in Multer's req.body during storage key generation
    formData.append("dealerId", dealerId);
    formData.append("file", file);
    
    return http.post(`/homepage-categories/upload?dlid=${dealerId}`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

const HomepageCategoriesService = {
    getAll,
    get,
    create,
    update,
    remove,
    uploadImage,
};

export default HomepageCategoriesService;
